import React from 'react';
import PropTypes from 'prop-types';

const Status = ({ asset }) => {
  const statusMap = {
    approved: t('Approved'),
    pending_approval: t('Pending approval'),
    unpublished: t('Draft'),
    expired: t('Expired')
  };

  const { availability, availability_end, availability_start } = asset.attributes;
  let statusModifier;

  if (availability !== 'unpublished' && availability !== 'expired') {
    if (availability_start && new Date(availability_start) > new Date()) {
      statusModifier = t(', unpublished');
    }

    if (availability_end && new Date(availability_end) < new Date()) {
      statusModifier = t(', expired');
    }
  }

  return (
    <div className="availability-row status-container">
      <h4>{t('Current status')}:</h4>
      <p className="status">{statusMap[availability] || t('Available')}{statusModifier}</p>
    </div>
  );
};

Status.propTypes = {
  asset: PropTypes.shape({
    attributes: PropTypes.shape({
      availability: PropTypes.string,
      availability_end: PropTypes.string,
      availability_start: PropTypes.string,
    })
  }).isRequired,
};

export default Status;
